export default __webpack_public_path__ + "static/media/ffb.267d395b.png";